import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBed2Filled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.5 7.57a1 1 0 011 1.01v4.08a.45.45 0 01-.45.45h-.57a.45.45 0 01-.45-.45v-1.45H2.97v1.45a.45.45 0 01-.45.45h-.57a.45.45 0 01-.45-.45V8.58a1 1 0 011-1zM12 2.52c.95 0 1.6.57 1.6 1.6v2.84h-2.62v-.5A1.37 1.37 0 009.6 5.1H6.3c-.75 0-1.36.6-1.36 1.36v.5H2.4V4.12c0-1 .65-1.6 1.6-1.6z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicBed2Filled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBed2Filled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicBed2Filled svgRef={ref} {...props} />);
export default ForwardRef;
